import { jsx } from 'react/jsx-runtime';
import { isBrowser, getClassNames } from '@websolutespa/bom-core';
import { useRef, useEffect, useImperativeHandle } from 'react';
import { useLlm } from '../../../useLlm/useLlm.js';
import { useLlmView } from '../../../useLlm/useLlmView.js';
import { Emitter } from './emitter.js';

const Scroller = _ref => {
  let {
    className = 'llm__scroller',
    selector = '.llm__content',
    children
  } = _ref;
  const innerRef = useRef(null);
  const scrollerRef = useRef(null);
  const app = useLlm(state => state.app);
  const introed = useLlmView(state => state.introed);
  const {
    setScroller,
    setScrollable
  } = useLlmView(state => state.actions);
  const allowScroll = !(app === null || app === void 0 ? void 0 : app.contents.customIntro) || introed;
  useEffect(() => {
    if (innerRef.current) {
      if (!allowScroll) {
        innerRef.current.scrollTo(0, 0);
      }
    }
  }, [allowScroll]);
  useImperativeHandle(scrollerRef, () => {
    const emitter = new Emitter();
    const ref = Object.assign(emitter, {
      scrollTo: (target, options) => {
        if (innerRef.current) {
          const position = {
            x: 0,
            y: 0
          };
          if (typeof target === 'number') {
            position.y = target;
          } else if (typeof target === 'string') {
            switch (target) {
              case 'top':
                position.y = 0;
                break;
              case 'bottom':
                position.y = innerRef.current.scrollHeight;
                break;
            }
          } else ;
          innerRef.current.scrollTo(position.x, position.y);
        }
      },
      start: () => {
        /*
        if (innerRef.current) {
        }
        */
      },
      stop: () => {
        /*
        if (innerRef.current) {
        }
        */
      }
    });
    setScroller(ref);
    return ref;
  }, [setScroller]);
  useEffect(() => {
    if (isBrowser && innerRef.current && scrollerRef.current) {
      const element = innerRef.current;
      const scroller = scrollerRef.current;
      let lastY = 0;
      const onScroll = () => {
        const limit = element.scrollHeight - element.offsetHeight;
        const targetScroll = element.scrollTop;
        const direction = targetScroll > lastY ? 1 : targetScroll === lastY ? 0 : -1;
        scroller.emit('scroll', {
          limit,
          targetScroll,
          direction
        });
        lastY = targetScroll;
      };
      element.addEventListener('scroll', onScroll);
      return () => {
        element.removeEventListener('scroll', onScroll);
      };
    }
    return () => {};
  }, []);
  useEffect(() => {
    // console.log('useCanvasOffscreen', canvasRef.current);
    if (isBrowser && innerRef.current && scrollerRef.current) {
      const scroller = scrollerRef.current;
      const element = innerRef.current;
      const target = element.querySelector(selector);
      if (target) {
        const onResize = _ref2 => {
          // const entryHeight = entry.contentRect.height;
          const limit = element.scrollHeight - element.offsetHeight;
          const targetScroll = element.scrollTop;
          // const scrollable = limit - targetScroll > 100;
          // console.log('onResize', limit, targetScroll, scrollable);
          scroller.emit('scroll', {
            limit,
            targetScroll,
            direction: 0
          });
        };
        const observer = new ResizeObserver(onResize);
        observer.observe(target);
        return () => {
          observer.disconnect();
        };
      }
      return () => {};
    } else {
      return () => {};
    }
  }, [innerRef, selector]);
  const classNames = getClassNames(className, {
    '-scroller-disabled': !allowScroll
  });
  return jsx("div", {
    ref: innerRef,
    className: classNames,
    children: children
  });
};

export { Scroller };
//# sourceMappingURL=scroller.js.map
